import Swiper from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperPropertySingle() {
    const thumbs = new Swiper(".property-single__thumbs", {
        slidesPerView: 3.33,
        spaceBetween: 16,
        loop: true,
        grabCursor: true,
        speed: 1000,

        breakpoints: {
            768: {
                slidesPerView: 4.33,
            },
        },
    });

    const swiper = new Swiper(".property-single__swiper", {
        modules: [Navigation, Pagination, Thumbs],

        loop: true,
        grabCursor: true,
        speed: 1000,

        navigation: {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
        },

        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },

        thumbs: {
            swiper: thumbs,
        },

        // Parallax
        watchSlidesProgress: true,
        on: {
            progress() {
                const swiper = this;

                const parallaxFactor = 0.5;
                const parallaxOffset = swiper.width * parallaxFactor;

                swiper.slides.forEach((slide) => {
                    const parallaxTranslate = slide.progress * parallaxOffset;
                    const parallaxElement = slide.firstElementChild;

                    if (parallaxElement) {
                        parallaxElement.style.transform = `translate3d(${parallaxTranslate}px, 0, 0)`;
                    }
                });
            },
        },
    });
}
